import React, { useRef, useContext, createContext, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const RefContext = createContext();

export const RefProvider = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const appointmentRef = useRef(null);
  const scrollToAppointment = () => {
    if (appointmentRef.current) {
      const elementPosition =
        appointmentRef.current.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - 100; // Adjust the -100 as needed for the desired offset

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    } else {
      navigate("/contact", { state: { scrollToAppointment: true } });
    }
  };

  useEffect(() => {
    if (
      location.pathname === "/contact" &&
      location.state?.scrollToAppointment
    ) {
      const timeoutId = setTimeout(() => {
        if (appointmentRef.current) {
          appointmentRef.current.scrollIntoView({ behavior: "smooth" });

          // Adjust scroll position after the scrollIntoView
          window.scrollBy(0, -100); // Adjust the value as needed
        }
      }, 500); // Adjust the timeout delay if necessary

      return () => clearTimeout(timeoutId);
    }
  }, [location, appointmentRef]);

  return (
    <RefContext.Provider value={{ appointmentRef, scrollToAppointment }}>
      {children}
    </RefContext.Provider>
  );
};

export const useRefContext = () => useContext(RefContext);
